import { Button as MuiButton, type ButtonProps as MuiButtonProps } from '@mui/material';
import { forwardRef } from 'react';

/**
 * FSE Button. Thin wrapper over MUI Button with FSE defaults.
 * Public API is a superset of MUI's — keep adding props here as we
 * discover patterns, but never let MUI-specific names leak (e.g.
 * don't expose `variant: "contained"`; alias to `kind: "primary"`).
 */
export type ButtonProps = MuiButtonProps;

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  props,
  ref,
) {
  return <MuiButton ref={ref} variant="contained" {...props} />;
});
